import GeneralProduct from '~/Api/Product/Product';

import ReferencePrice from './ReferencePrice';

export default class Product {
	product: GeneralProduct;

	dosageStrengthForCalculation: number | null;

	packageSizeForCalculation: number | null;

	packageSizeForSingleUnit: number | null;

	singleUnitPackageSize: boolean;

	referencePrices: ReferencePrice[];

	selectable: boolean;

	selected: boolean;

	referenceDataSource: boolean;

	constructor(
		product: GeneralProduct,
		dosageStrengthForCalculation: number | null,
		packageSizeForCalculation: number | null,
		packageSizeForSingleUnit: number | null,
		singleUnitPackageSize: boolean,
		referencePrices: ReferencePrice[],
		selectable: boolean,
		selected: boolean,
		referenceDataSource: boolean
	) {
		this.product = product;
		this.dosageStrengthForCalculation = dosageStrengthForCalculation;
		this.packageSizeForCalculation = packageSizeForCalculation;
		this.packageSizeForSingleUnit = packageSizeForSingleUnit;
		this.singleUnitPackageSize = singleUnitPackageSize;
		this.referencePrices = referencePrices;
		this.selectable = selectable;
		this.selected = selected;
		this.referenceDataSource = referenceDataSource;
	}

	findSelectedReferencePrice(): ReferencePrice | null {
		return this.referencePrices.find((price) => price.calculatedPrice.selected) ?? null;
	}
}
